import { useEffect, useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    IconButton,
    Box,
    HStack,
} from '@chakra-ui/react';
import { CloseIcon, DownloadIcon } from '@chakra-ui/icons';
import useEmblaCarousel from 'embla-carousel-react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

function FullscreenImageViewer({ images = [], initialIndex = 0, isOpen, onClose }) {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });

    useEffect(() => {
        if (emblaApi) {
            emblaApi.scrollTo(initialIndex);
        }
    }, [emblaApi, initialIndex]);


    const handleDownload = (key) => {
        if (!key) return;
        fetch(key, {
            mode: 'cors', // needed if your S3 bucket has CORS enabled
        })
            .then((response) => {
                if (!response.ok) throw new Error('Failed to fetch image');
                return response.blob();
            })
            .then((blob) => {
                const a = document.createElement('a');
                a.href = URL.createObjectURL(blob);
                a.download = key.split('/').pop(); // download with file name only
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
            .catch((err) => {
                console.error('Download failed:', err);
            });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
            <ModalOverlay />
            <ModalContent
                bg="black"
                p={0}
                overflow="hidden"
                position="relative"
                maxW="90vw"
                maxH="90vh"
                w="auto"
                h="auto"
                borderRadius="12px"
                border={"3px solid #ccc"}
            >
                <HStack position="absolute" top="4" right="4" zIndex="10" spacing="2">
                    <IconButton
                        icon={<DownloadIcon />}
                        aria-label="Download"
                        colorScheme="whiteAlpha"
                        onClick={() => {
                            const currentIndex = emblaApi?.selectedScrollSnap() || 0;
                            handleDownload(images[currentIndex]);
                        }}
                    />
                    <IconButton
                        icon={<CloseIcon />}
                        aria-label="Close"
                        onClick={onClose}
                        colorScheme="whiteAlpha"
                    />
                </HStack>
                <Box ref={emblaRef} w="100%" h="100%" overflow="hidden">
                    <Box display="flex" h="100%">
                        {images.map((src, index) => (
                            <Box
                                key={index}
                                flex="0 0 100%"
                                h="100vh"
                                w="100vw"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                overflow="hidden"
                            >
                                <TransformWrapper
                                    doubleClick={{ disabled: true }}
                                    pinch={{ disabled: false }}
                                    wheel={{ step: 50 }}
                                    panning={{ velocityDisabled: true }}
                                >
                                    <TransformComponent>
                                        <img
                                            src={src}
                                            alt={`Image ${index}`}
                                            style={{
                                                marginBottom: '100px',
                                                maxWidth: '90vw',
                                                maxHeight: '80vh',
                                                objectFit: 'contain',
                                                userSelect: 'none',
                                                touchAction: 'none',
                                            }}
                                        />
                                    </TransformComponent>
                                </TransformWrapper>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </ModalContent>
        </Modal>
    );
}

export default FullscreenImageViewer;